const megaMenus = document.querySelectorAll('.mega-menu')
const siteMenu = document.querySelector('.site-menu')
const topMenu = document.querySelector('.top-menu')
const megaMenuTriggers = document.querySelectorAll('[data-mega-menu-trigger]')
const megaMenuClose = document.querySelectorAll('[data-mega-menu-close]')
const xlargeWidthBreakpoint = 1340
var currentMegaMenu = undefined
var mouseLeftTick = 0;

// Methods
const closeAllMegaMenus = () => megaMenus.forEach(m => {
    m.classList.remove('is-open')
})
const openMegaMenu = trigger => {
    const megaMenu = trigger.parentElement.querySelector('.mega-menu')

    // cancel opening menu if the user is on desktop and the targeted mega menu is mobile only.
    if (window.innerWidth >= xlargeWidthBreakpoint && megaMenu.classList.contains("mega-menu--mobile-only")) {
        return
    }
    closeAllMegaMenus()
    megaMenu.classList.add('is-open')
}
const openNextMegaMenu = trigger => {
    const megaMenu = trigger.parentElement.querySelector('.mega-menu')
    const parentMegaMenu = currentMegaMenu
    if (parentMegaMenu != undefined) {
        parentMegaMenu.scrollTop = 0
    }
    megaMenu.classList.add('is-open')
    topMenu.classList.add('is-off-screen')
    siteMenu.classList.add('mega-menu-is-open')
    currentMegaMenu = megaMenu
}

// Events
megaMenuTriggers.forEach(trigger => {

    // On desktop we want the Mega Menu to appear on hover
    trigger.addEventListener('mouseenter', e => {
        if (window.innerWidth >= xlargeWidthBreakpoint) {
            //mouseLeftMegaNav = false;
            openMegaMenu(trigger)
        }
    })
    // If navigation is happening with the keyboard we also want to display the mega menu when pressing "Enter"
    trigger.addEventListener('keyup', e => {
        if (e.keyCode === 13) {
            openMegaMenu(trigger)
        }
    })

    // But on mobile it has to happen on click
    trigger.addEventListener('click', e => {
        if (window.innerWidth < xlargeWidthBreakpoint) {
            e.preventDefault()
            openNextMegaMenu(trigger)
        }
    })

})

siteMenu.addEventListener('mouseleave', e => {
    if (window.innerWidth >= xlargeWidthBreakpoint) {
        var tick = new Date().getTime();
        mouseLeftTick = tick;
        setTimeout(() => {
            if (mouseLeftTick == tick) {
                closeAllMegaMenus();
            }
        }, 250);
    }
})

siteMenu.addEventListener('mouseenter', e => {
    if (window.innerWidth >= xlargeWidthBreakpoint) {
        mouseLeftTick = 0;
    }
})

megaMenuClose.forEach(trigger => {
    trigger.addEventListener('click', e => {
        e.stopPropagation()
        e.target.closest('.mega-menu.is-open').classList.remove('is-open')
        var parentMegaMenu = e.target.closest('.mega-menu.is-open')
        if (parentMegaMenu == null) {
            currentMegaMenu = undefined
            topMenu.classList.remove('is-off-screen')
            siteMenu.classList.remove('mega-menu-is-open')
        } else {
            currentMegaMenu = parentMegaMenu
        }
    })
})